import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom'; // Need this to push to history and redirect user properly
import { CardElement, injectStripe } from 'react-stripe-elements';
// import { RealexRemote } from '../../../utils/rxp-js.js';

// Components
import Modal from '../../modal/Modal';
import Button from '../../modal/Button';
import GeneralLoader from '../../GeneralLoader';
// import PaymentForm from './PaymentForm';

// State
import { sendPaymentStripe, resetPaymentErrors } from '../../../store/actions/checkout';

// CSS
import '../../../css/payment.css';
import '../../../css/stripe.css';

// Util
import { setTransaction as setTransactionGA } from '../../../utils/google-analytics';

class PaymentSection extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loading: false,
			showPaymentModal: false,
			// uncomment the line below when going to test mode
			// stripe: null
			// globalPaymentErrors: false,
			// paymentInfo: {
			// 	card: '',
			// 	cardholder: '',
			// 	expiryMonth: '',
			// 	expiryYear: '',
			// 	cvn: '',
			// },
		};

		this.submit = this.submit.bind(this);
		this.validateStripe = this.validateStripe.bind(this);
		// this.validatePayment = this.validatePayment.bind(this);
		// this.handleCardInfoInput = this.handleCardInfoInput.bind(this);
	}

	componentWillReceiveProps(nextProps) {
		// If errors exist and payment isn't processing anymore
		if (this.props.loading && !nextProps.loading) {
			this.setState({ showPaymentModal: false });
		}
	}

	handleKeyPress(event) {
		if (event.key === 'Enter') {
			this.handleSubmit(event);
		}
	}

	// handleCardInfoInput(eventValue, property) {
	// 	this.setState({
	// 		paymentInfo: {
	// 			...this.state.paymentInfo,
	// 			[property]: eventValue
	// 		}
	// 	});
	// }

	submit(ev) {
		ev.preventDefault();

		this.props.resetPaymentErrors();

		// Show modal
		this.setState(
			{
				stripeErrors: false,
				loading: true,
				showPaymentModal: true,
			},
			() => {
				// Handle Stripe
				this.validateStripe(ev);
			}
		);
	}

	async validateStripe(ev) {
		try {
			const { fname, lname, address, address_2, city, postal, province, country } = this.props.billingAddress;
			//uncomment the line below to go into test mode as well as the stripe state at the top of this file
			// this.setState({
			// 	stripe: window.Stripe("pk_test_PDzQFir3QmKJokgaZszdfOU9")
			// });
			const tokenResponse = await this.props.stripe.createToken({
				name: fname + " " + lname,
				address_line1: address,
				address_line2: address_2,
				address_city: city,
				address_zip: postal,
				address_state: province,
				address_country: country,
				// name: this.props.store.billingAddress.addresses[0].fname + " " + this.props.store.billingAddress.addresses[0].lname,
				// name: "lam"
				// email: this.props.userEmail
				// name: "lami",,

				// description: this.props.itemName
			});

			if (tokenResponse.error) {
				this.setState({ loading: false, stripeErrors: tokenResponse.error.message });
				return;
			}

			// Send payment to API
			this.props.sendPaymentStripe(tokenResponse.token.id).then((resp) => {
				// All good, gonna clean up and leave this component/page
				if (resp !== undefined) {
					// Send transaction to GA
					setTransactionGA(resp.transaction, this.props.campaignName);
					// console.log("this is the resp variable", resp);
					// If successfully called, push the user to the receipt page
					this.props.history.push(
						'/order-summary?order=' + resp.order + '&access=' + resp.access_token
					);
				}
				// Some junk happened, so lets make sure we're not loading anymore
				else {
					this.setState({ loading: false });
				}
			});
		} catch (err) {
			console.log(err);
		}
	}

	// async validatePayment(ev) {
	// 	try {
	// 		let paymentInfo = this.state.paymentInfo;
	// 		let cardNum = paymentInfo.card.replace(/\s+/g, '');
	// 		let cvnCheck = '';
	// 		// Validate payment inputs
	// 		let cardNumberCheck = RealexRemote.validateCardNumber(cardNum);
	// 		let cardHolderNameCheck = RealexRemote.validateCardHolderName(paymentInfo.cardholder);
	// 		let expiryDate = paymentInfo.expiryMonth + paymentInfo.expiryYear;
	// 		let expiryDateFormatCheck = RealexRemote.validateExpiryDateFormat(expiryDate);
	// 		let expiryDatePastCheck = RealexRemote.validateExpiryDateNotInPast(expiryDate);
	// 		if (cardNum.charAt(0) == "3") {
	// 			cvnCheck = RealexRemote.validateAmexCvn(paymentInfo.cvn);
	// 		} else {
	// 			cvnCheck = RealexRemote.validateCvn(paymentInfo.cvn);
	// 		}

	// 		// Check values & display the appropriate errors
	// 		if(cardNumberCheck === false) {
	// 			this.setState({ loading: false, validationErrors: 'Please enter the number as it appears on the credit card' });
	// 		} else if(cardHolderNameCheck === false) {
	// 			this.setState({ loading: false, validationErrors: 'Please enter the name as it appears on the credit card.' });
	// 		} else if(expiryDateFormatCheck === false) {
	// 			this.setState({ loading: false, validationErrors: 'Please enter the month and year as they appears on the credit card.' });
	// 		} else if(expiryDatePastCheck === false) {
	// 			this.setState({ loading: false, validationErrors: 'This credit card has expired, please use a valid credit card.' });
	// 		} else if(paymentInfo.cvn.length < 3) {
	// 			this.setState({ loading: false, validationErrors: 'Please enter the three or four digit CCV number.  This is usually on the back on the card.' });
	// 		} else if(cvnCheck === false) {
	// 			this.setState({ loading: false, validationErrors: 'The CCV number is invalid.' });
	// 		} else {
	// 			// Send payment to API
	// 			this.props.sendPaymentGlobalPayments(paymentInfo).then((resp) => {
	// 				this.setState({ loading: false });
	// 				// All good, gonna clean up and leave this component/page
	// 				if (resp !== undefined) {
	// 					// Send transaction to GA
	// 					setTransactionGA(resp.transaction);
	// 					// console.log("this is the resp variable", resp);
	// 					// If successfully called, push the user to the receipt page
	// 					this.props.history.push(
	// 						'/order-summary?order=' + resp.order + '&access=' + resp.access_token
	// 					);
	// 				}
	// 				// Some junk happened, so lets make sure we're not loading anymore
	// 				else {
	// 					this.setState({ loading: false });
	// 				}
	// 			});
	// 		}
	// 	} catch (err) {
	// 		console.log(err);
	// 	}
	// }

	render() {
		const { errors } = this.props;
		const { loading, stripeErrors } = this.state;
		
		return (
			<div>
				<div className="delivery-heading">
					<h2>Enter card info:</h2>
				</div>

				<div className="shipping-form tight-form-fields">
					<div className="pb1">
						<CardElement hidePostalCode={true} />
						{/* <PaymentForm 
							paymentInfo={this.state.paymentInfo} 
							handleInput={this.handleCardInfoInput}
						/> */}
					</div>

					<div className="btn_container">
						{errors.general && <div className="error">{errors.general}</div>}
						<button
							className={'btn submit-btn' + (loading ? ' loading' : '')}
							onClick={this.submit}
							disabled={loading}
						>
							<span>Submit Order</span>
						</button>
					</div>

					{/* PAYMENT MODAL */}
					{this.state.showPaymentModal && (
						<Modal
							title={'Payment Processing'}
							buttons={[
								{
									type: Button,
									text: 'Close',
									action: () => this.setState({ showPaymentModal: false }),
									disabled: this.props.loading,
								},
							]}
						>
							{loading && <GeneralLoader />}
							{!loading &&
								(stripeErrors ? (
									<div className="error">{stripeErrors}</div>
								) : (
									<div>Done</div>
								))}
						</Modal>
					)}
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		store: state,
		userEmail: state.user.customer ? state.user.customer.user.email : 'guest',
		loading: state.checkout.paymentInProcess,
		errors: state.checkout.paymentErrors,
		billingAddress: state.checkout.billing,
		campaignName: state.siteInfo.campaignName,
	};
};

export default withRouter(
	injectStripe(
		connect(
			mapStateToProps,
			{ sendPaymentStripe, resetPaymentErrors }
		)(PaymentSection)
	)
);



// WEBPACK FOOTER //
// ./src/components/checkout/payment/PaymentSection.js